import { JournalDtoTopic, TaskDto, TaskDtoTaskType } from '../../api/generated/model';
import { TaskFilter } from '../../state/taskSearchAtoms.ts';

// Journal entries carry no DOT marker, so a therapy note counts as DOT compliance
// only when its text names one.
const DOT_NOTES_PATTERN = /\bdot\b/i;

function isDotComplianceTask(task: TaskDto) {
  if (task.taskType === TaskDtoTaskType.THERAPY_COMPLIANCE_OVERDUE) {
    return true;
  }

  return (
    task.taskType === TaskDtoTaskType.NOTE_WITH_TODO &&
    task.journal?.topic === JournalDtoTopic.THERAPY &&
    DOT_NOTES_PATTERN.test(task.journal.notes)
  );
}

export function getTaskFilterName(taskFilter: TaskFilter) {
  switch (taskFilter) {
    case TaskFilter.ALL:
      return 'Alle';
    case TaskFilter.APPOINTMENT:
      return 'Termin';
    case TaskFilter.COMPLIANCE_OVERDUE:
      return 'DOT Compliance';
    case TaskFilter.JOURNAL:
      return 'Notiz';
    case TaskFilter.TEST_RESULT_INCOMPLETE:
      return 'Testresultat';
    case TaskFilter.WAITING_PERIOD_OVER:
      return 'Wartefrist';
  }
}

export function filterTasks(tasks: TaskDto[], taskFilter: TaskFilter) {
  switch (taskFilter) {
    case TaskFilter.ALL:
      return tasks;
    case TaskFilter.APPOINTMENT:
      return tasks.filter((task) => task.taskType === TaskDtoTaskType.APPOINTMENT_TODAY);
    case TaskFilter.COMPLIANCE_OVERDUE:
      return tasks.filter(isDotComplianceTask);
    case TaskFilter.JOURNAL:
      return tasks.filter((task) => task.taskType === TaskDtoTaskType.NOTE_WITH_TODO);
    case TaskFilter.TEST_RESULT_INCOMPLETE:
      return tasks.filter((task) => task.taskType === TaskDtoTaskType.TEST_RESULT_INCOMPLETE);
    case TaskFilter.WAITING_PERIOD_OVER:
      return tasks.filter((task) => task.taskType === TaskDtoTaskType.TRACING_WAITING_PERIOD_OVER);
  }
}
